<script setup>
import { watch, ref } from 'vue';
import { storeToRefs } from "pinia";

const props = defineProps(['role', 'roleKey', 'setCap', 'caps']);

const capabilities = ref([]);
watch(() => {
    const roleCaps = props.role.capabilities;
    const { capabilities: caps } = window.fv_role_manager_data;
    const cap = {};
    Object.keys(caps).forEach((capKey) => {
        cap[capKey] = {};
        Object.keys(caps[capKey]).forEach((key) => {
            cap[capKey][key] = {
                label: caps[capKey][key],
                enabled: roleCaps[key] ?? false,
            };
        });
    });

    capabilities.value = cap;
})

const onChangeSwitch = (value,key,user) => {
    props.setCap({
        ...props.caps,
        [user]:{
            ...props.caps[user],
            [key] : value
        }
    });
}
</script>
<template>
    <div>
        <div>
            <div>
                <div v-for="(cap,key,index) in capabilities" :key="index">
                    <span class="fv-feature-heading">
                        {{key.charAt(0).toUpperCase() + key.substring(1)}}
                    </span>
                    <ul>
                        <li v-for="(capVal, capValKey, capKey) in cap" :key="capKey">
                            <div>
                                <el-switch
                                    v-model="capVal.enabled"
                                    style="margin-left: 24px; margin-right: 15px;"
                                    inline-prompt
                                    :active-icon="Check"
                                    :inactive-icon="Close"
                                    @change="onChangeSwitch($event,capValKey,roleKey)"
                                />
                                <span>
                                    {{ capVal.label }}
                                </span>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>